import avatarModule from '../avatarModule';

function avatarTabContentHeader(avatarUrlConstants) {
  'ngInject';

  return {
    restrict: 'A',
    replace: false,
    templateUrl: avatarUrlConstants.templates.avatarTabContentHeader
  };
}

avatarModule.directive('avatarTabContentHeader', avatarTabContentHeader);

export default avatarTabContentHeader;
